import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {findModalContent} from "./modalHelpers";
import Modal from "./Modal";

const hiddenModalGlobals = {};

/**
 * Runs on startup. Looks for any static content like:
 *
 * <a class="hidden-modal-trigger" data-target="#my-content">click me</a>
 * <div id="my-content" class="hidden-modal-content">  // this has display-none
 *   my content lives here
 * </div>
 *
 * @param props
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export default function HiddenModalActivator({...props}) {

  const [content, setContent] = useState(null);

  const handleTriggerClicked = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const trigger = evt.target;

    const contentSource = findModalContent(trigger, 0);
    if (contentSource) {
      let clone = contentSource.cloneNode(true)
      if (clone.classList)
        clone.classList.remove('hidden-modal-content');

      setContent(clone);
    } else {
      setContent(null);
      console.error("Failed to find modal content");
    }
  }

  // make available outside this function
  hiddenModalGlobals.triggerClicked = handleTriggerClicked;

  // STARTUP - bind all the triggers in the page.
  useEffect(() => {
    activateHiddenModals();
  }, []); // run only once

  const handleCloseModal = (evt) => {
    setContent(null);
  }

  if (!content) return null;

  return <Modal
    handleClose={handleCloseModal} contentNode={content} />
}

// Also called by the ReviewInserter
export function activateHiddenModals(container) {
  container ||= document.getElementsByTagName('body')[0];

  let triggers = container.getElementsByClassName('hidden-modal-trigger');

  const handleTriggerClicked = evt => {
    if (hiddenModalGlobals.triggerClicked)
      hiddenModalGlobals.triggerClicked(evt);
    else
      console.error("no hiddenModalGlobals.triggerClicked");
  }

  for (let t of triggers) {
    t.onclick = handleTriggerClicked;
  }

}
